import {
  DocumentNode,
  OperationVariables,
  QueryLazyOptions,
  QueryOptions,
  useApolloClient,
} from '@apollo/client';
import { useCallback } from 'react';

/*
  Apollo's useLazyQuery returns errors as part of the query but does not throw them.
  Until this behavior is changed, we will continue to use our own implmentation that
  bubbles up errors correctly.

  https://github.com/apollographql/apollo-client/issues/9669#issuecomment-1137340315
*/

export const useLazyQuery = <
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  TData = any,
  TVariables extends OperationVariables = OperationVariables,
>(
  query: DocumentNode,
  options?: Omit<QueryOptions<TVariables>, 'query'>,
) => {
  const client = useApolloClient();
  return useCallback(
    async (lazyOptions: QueryLazyOptions<TVariables> = {}) => {
      return client.query<TData, TVariables>({
        query,
        ...(options || {}),
        ...lazyOptions,
      });
    },
    [client, options, query],
  );
};
